import { mediaGQLFields } from '../media/media.fields.js';
import { memberGQLFields } from '../network/member.fields.js';
import { spaceGQLFields } from '../space/space.fields.js';
const BASIC_SEARCH_ENTITY_FIELDS = {};
const ALL_SEARCH_ENTITY_FIELDS = {
    in: {
        image: 'basic',
    },
    by: 'basic',
    media: 'basic',
};
export function searchEntityGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_SEARCH_ENTITY_FIELDS;
    if (fields === 'all')
        fields = ALL_SEARCH_ENTITY_FIELDS;
    return `
    content
    created
    entityId
    id
    subtitle
    title
    entityType
    ${fields.in
        ? `
      in {
        ... on Space {
          ${spaceGQLFields(fields.in)}
        }
      }
    `
        : ``}
    ${fields.by
        ? `
      by {
        ... on Member {
          ${memberGQLFields(fields.by)}
        }
      }
    `
        : ``}
    ${fields.media
        ? `
      media {
        ${mediaGQLFields(fields.media)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=searchEntity.fields.js.map